import { get, post } from "@/requests/server";
import { extractErrors } from "@/helpers";
import i18n from "@/i18n";

export async function cancelInvitation(invitationId, data = null) {
  return await post(`/invitations/${invitationId}/cancel`, data, {
    notifications: {
      action: i18n.t("requests.invitation_requests.notifications.cancel.action"),
      onSuccess: i18n.t("requests.invitation_requests.notifications.cancel.success"),
    },
  });
}

export async function validateInvitation(id, code, email) {
  let validationResult = {};
  try {
    const { data } = await get(
      `/invitations/validate/${id}?code=${code}&email=${encodeURIComponent(email)}`,
      {
        requestOptions: { expects: [404] },
        notifications: {
          action: i18n.t("requests.invitation_requests.notifications.validate.action"),
          resourceName: i18n.t("requests.invitation_requests.notifications.validate.resource_name"),
        },
      }
    );

    validationResult = {
      codeValid: data.code_valid,
      isActive: data.is_active,
      accountExists: data.account_exists,
      communityName: data.community_name,
      inviterName: data.inviter_name,
      valid: data.code_valid && data.is_active,
      email: data.email,
    };

    // if no email was validated, do not set the validation state
    if (email) {
      validationResult.emailValid = data.email_valid;
      validationResult.valid = validationResult.valid && data.email_valid;
    }
  } catch (e) {
    validationResult = {
      notFound: e.request?.status === 404,
      valid: false,
      message: e.response?.data ? extractErrors(e.response.data).join(", ") : "",
    };
  }

  validationResult.message = getValidationMessage(validationResult, !!email);
  return validationResult;
}

function getValidationMessage(validationResult, hasEmail) {
  if (validationResult.notFound) {
    return i18n.t("requests.invitation_requests.validation.messages.not_found");
  }

  if (validationResult.isActive === false) {
    return i18n.t("requests.invitation_requests.validation.messages.expired");
  }

  if (validationResult.codeValid === false) {
    return i18n.t("requests.invitation_requests.validation.messages.invalid_code");
  }

  if (validationResult.emailValid === false && hasEmail) {
    return i18n.t("requests.invitation_requests.validation.messages.invalid_email");
  }

  return validationResult.message;
}
